export default {
  name: 'zhangjiajie',
  adcode: '430800',
  mapName: '张家界市',
  geoJsonPath: 'hunanmap/430800.json',
  backgroundImage: {
    png: '张家界市_430800.png',
    webp: '张家界市_430800.webp'
  },
  echartsMapStyle: {
    width: '913px',
    height: '597px',
    marginTop: 'auto',
    marginBottom: '119px',
  },
  imageSize: {
    width: 4212,
    height: 2756
  },
  // 地图特殊配置：背景图片适配参数
  specialConfig: {
    // 独立调整参数
    layoutSizeAdjustment: {
      enabled: true,
      multiplier: 1.52, // 布局尺寸调整倍数（微调）
      minSize: 400,     // 最小布局尺寸
      maxSize: 1200     // 最大布局尺寸
    },
    aspectScaleAdjustment: {
      enabled: true,
      multiplier: 1, // 宽高比调整倍数（微调）
      minScale: 0.5,    // 最小缩放比例
      maxScale: 2.0     // 最大缩放比例
    },
    // 位置偏移补偿
    positionOffset: {
      x: 0.001,  // X轴偏移百分比
      y: 0.001  // Y轴偏移百分比
    }
  },
  // 区县列表
  districts: ['张家界市区', '慈利县', '桑植县'],
  // 区县坐标映射（用于tooltip定位与涟漪效果）
  cityCoords: {
    // 市区参考坐标（用于兜底展示）
    '张家界市区': [110.348559, 29.169961],
    '张家界市': [110.348559, 29.169961],
    // 区县坐标（来自 430800.json center）
    '慈利县': [110.842702, 29.403876],
    '桑植县': [110.124039, 29.542939]
  },
  // 区县名称标准化
  normalizeName: (name) => {
    if (!name) return ''
    const s = String(name).trim()
    // 城区归并到“张家界市区”
    if (s === '张家界市') return '张家界市区'
    return s
  },
  // 区县与adcode映射
  cityAdcodeMap: {
    '永定区': '430802',
    '武陵源区': '430811',
    '慈利县': '430821',
    '桑植县': '430822'
  }
}